import { AssetClass } from '@monorepo/types';
import { WidgetStrategy } from '../../types/widget-manager.types';
import { ForexWidgetStrategy } from './forex-widget-strategy';
import { FuturesWidgetStrategy } from './futures-widget-strategy';
import { StocksWidgetStrategy } from './stocks-widget-strategy';

/**
 * Widget strategy factory
 * Creates appropriate strategy instance based on asset class
 */
export const getWidgetStrategy = (
  assetClass: AssetClass | null | undefined,
): WidgetStrategy | null => {
  if (!assetClass) {
    return null;
  }

  switch (assetClass) {
    case AssetClass.Forex:
      return new ForexWidgetStrategy();
    case AssetClass.Futures:
      return new FuturesWidgetStrategy();
    case AssetClass.Stocks:
      return new StocksWidgetStrategy();
    default:
      return null;
  }
};
